<template>
	<div>
		<div class="nodea" v-if="data.list.length == 0">
			<img src="../../../../assets/img/nodata.png" >
		</div>
		<div class="list_box" v-for="(item, index) in data.list" @click="goDeatils(i,item)" :key="index" >
			<div class="two-overflow type_size_22">
				{{item.job_name}}
			</div>
			<div class="p_flex type_size_16 p_m_t_20">
				<span class="subject_color">{{item.classLevel.name}}</span>
				<el-divider direction="vertical"></el-divider>
				<span class="subject_yellow">{{item.subject_def}}</span>
				<el-divider direction="vertical"></el-divider>
				<span>{{item.student.name}}</span>
				<el-divider direction="vertical"></el-divider>
				<span>{{item.question_count}}道题</span>
				<el-divider direction="vertical"></el-divider>
				<span>{{item.score}}分</span>
			</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20" >
				<div class="p_flex type_size_16">提交时间 {{item.publish_date}} 至 {{item.submit_date}}</div>
				<div class="p_flex p_f_a">
					<span   class=" subject_color type_size_22 p_m_r_30">{{item.total_score}}分</span>
					<el-button type="success" size="mini">查看详情</el-button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			count: 10,
			loading: false
		};
	},
	props: {
		i:{type:Number, default:0},
		data:{type:Object, default:{ list:[], count:0 }}
	},
	computed: {


	},
	mounted() {},
	methods: {

		goDeatils(i,item) {
			this.$router.push({
				path: '/Deatilm',
				query:{
					type:i,
					jobType: item.job_type,		// 1.习题册，2.答题卡
					jobSubmitId: item.id,
					status: (i==0)?3:1		// 错题状态
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
.type_size_22 {
	line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/list.vue